import React from 'react';
import {Card, CardActions, CardText} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import TextField from 'material-ui/TextField';
import { translate } from 'react-i18next';
import Snackbar from 'material-ui/Snackbar';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import createHistory from 'history/createBrowserHistory';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

class ProductCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      description: '',
      price: 0,
      vat: '0',
      productKey: null,
      savedSnackbar: false
    };
  }

  componentDidMount = () => {
    const {productKey} = this.props;
    const {shopkeeperId} = this.props.user;
    if (productKey && shopkeeperId ) {
      this.setState({productKey});
      this.getProduct(productKey, shopkeeperId);
    }
  }

  getProduct = (productKey, shopkeeperId) => {
    const {firebase} = this.props;
    firebase
      .database()
      .ref(`shopkeepers/${shopkeeperId}/products/${productKey}`)
      .once('value')
      .then((data) => {
        this.setState({...data.val()});
      });
  }

  handleSave = () => {
    const {firebase, user} = this.props;

    const valid = [this.validateName, this.validatePrice].map((fn) => fn()).every(x => (x));
    if (!valid) return;

    const product = {
      name: this.state.name,
      description: this.state.description,
      price: this.state.price,
      vat: this.state.vat
    };

    const {productKey} = this.state;

    firebase.database()
      .ref(`shopkeepers/${user.shopkeeperId}/products/${productKey}`)
      .update(product);

    this.setState({savedSnackbar: true});
  }

  closeSnackbar = () => {this.setState({savedSnackbar: false});}

  handleNameChange = (event, name) => this.setState({name, nameError: ''})
  handleDescriptionChange = (event, description) => this.setState({description})
  handlePriceChange = (event, price) => this.setState({price: price.trim().replace(',','.'), priceError: ''})
  handleVatChange = (event, index, vat) => this.setState({vat})

  validateName = () => {
    const {t} = this.props;
    if (!this.state.name) {
      this.setState({nameError: t('product.nameRequired')});
      return false;
    }
    return true;
  }

  validatePrice = () => {
    const price = this.state.price;
    const {t} = this.props;

    if (!price) {
      this.setState({priceError: t('product.priceRequired')});
      return false;
    } else if (isNaN(price)) {
      this.setState({priceError: t('product.priceNotNumber')});
      return false;
    } else if (parseFloat(price) < 0)  {
      this.setState({priceError: t('product.priceLessThanZero')});
      return false;
    } else if (parseFloat(parseFloat(price).toFixed(2)) !== parseFloat(price)) {
      this.setState({priceError: t('product.tooManyDecimals')});
      return false;
    }

    return true;
  }

  render()  {
    const {t} = this.props;

    return (
      <Card className='cardStyle' >
        <Toolbar>
          <ToolbarGroup firstChild={true}>
            <IconButton
              onTouchTap={createHistory().goBack}
            >
              <ArrowBack color="rgba(0,0,0,0.4)" />
            </IconButton>
            <ToolbarTitle text={t('product.product')} />
          </ToolbarGroup>
        </Toolbar>
        <CardText>
          <TextField
            hintText={t('product.name')}
            floatingLabelText={t('product.name')}
            onChange={this.handleNameChange}
            value={this.state.name}
            onBlur={this.validateName}
            errorText={this.state.nameError}
          />
          <br />
          <TextField
            hintText={t('product.description')}
            floatingLabelText={t('product.description')}
            multiLine={true}
            onChange={this.handleDescriptionChange}
            value={this.state.description}
          />
          <br />
          <TextField
            hintText={t('product.defaultPrice')}
            floatingLabelText={t('product.defaultPrice')}
            onChange={this.handlePriceChange}
            value={this.state.price}
            onBlur={this.validatePrice}
            errorText={this.state.priceError}
          />
          <br />
          <span style={{fontSize: '11px', color: '#BDBDBD'}}>
            {t('product.defaultPriceDesc')}
          </span>
          <br />
          <SelectField
            autoWidth={true}
            floatingLabelText={t('product.vat')}
            value={this.state.vat}
            onChange={this.handleVatChange}>
            <MenuItem value={'0'} primaryText="0 %" />
            <MenuItem value={'10'} primaryText="10 %" />
            <MenuItem value={'14'} primaryText="14 %" />
            <MenuItem value={'24'} primaryText="24 %" />
          </SelectField>
        </CardText>

        <CardActions>
          <RaisedButton label={t('save')} primary  onTouchTap={this.handleSave} />
        </CardActions>

        <Snackbar
          open={this.state.savedSnackbar}
          message={t('product.saved')}
          autoHideDuration={4000}
          onRequestClose={this.closeSnackbar}
        />

      </Card>
    );
  }

}

const enhance = compose(translate(), firebase, user);

export default enhance(ProductCard);



// WEBPACK FOOTER //
// ./src/Product/ProductCard.js